import React, { useEffect, useState } from 'react';
import userAuth from '../../Config/userauth';
import { DEFAULT_HEADER } from '../../Config/userToken';
import { APPCONFIG } from '../../app.config';
import InfoCard from '../InfoCard';

const HomeUserInfo = () => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const userId = userAuth.userId();
    loadUserInfo(userId);
  }, []);

  const loadUserInfo = async (userId) => {
    const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

    try {
      const response = await fetch(`${PRODUCERURL}api/producer/GetProducerById?userId=${userId}`, {
        method: 'GET',
        headers: DEFAULT_HEADER.get()
      });
      const data = await response.json();
      if (data?.success && data.user) {
        setUserInfo(data);
      }
    } catch (err) {
      console.error("Error al obtener los datos del usuario:", err);
    }
  };


  const handleClick = () => {
    window.open('./user-dashboard-info', '_self');
  };

  const renderField = (icon, content) => (
    <div className="row pb-3">
      <div className="col-1 campo-titulo"><i className={`fa ${icon}`} /></div>
      <div className="col-10 campo-valor">{content}</div>
    </div>
  );

  return (
    <InfoCard
      title="Mis datos"
      icon="fa-user"
      actions={
        <button onClick={handleClick}>
          <i className="fa fa-edit text-white" title="Editar datos"></i>
        </button>
      }
    >
      {userInfo ? (
        <>
          <div className="row justify-content-between align-items-center">
            <span className="d-flex flex-column col">
              {renderField("fa-user", `${userInfo.name} ${userInfo.lastName}`)}
              {renderField("fa-phone", userInfo.telephone)}
              {renderField("fa-envelope", userInfo.email)}
              {userAuth.isGestor() && renderField("fa-user-plus", <span>En representación del usuario CUIT: <span><b>{userAuth.reportTo()}</b></span></span>)}
            </span>
          </div>
        </>
      ) : (
        <div className="text-center">Cargando datos...</div>
      )}
    </InfoCard>
  );
};

export default HomeUserInfo;
